/**
 * Screen Recorder & Screenshot App for Chrome (scrnli)
 *
 * Injects its recorder UI roots into every page rather than only when recording.
 * Observed on version 4.3.8.
 */
import { probeSelector } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'ijejnggjjphlenbhmjhhgcdpehhacaal';
export const scrnliRecorder: ExtensionDefinition = {
  id: ID,
  name: 'Screen Recorder & Screenshot App for Chrome',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  signals: [
    { id: 'dom-recorder-root', kind: 'dom',
      description: 'Look for #scrnli_recorder_root / #recorder_selected_root, injected on page load.',
      weight: 1, run: () => probeSelector('#scrnli_recorder_root, #recorder_selected_root', { timeoutMs: 1500 }) },
  ],
};
